// Toggle del textarea custom_reason en el modal de cancelación según
// la razón seleccionada. Replica el `reason === 'Otro' && <textarea>`
// condicional de CommunitySaasCancelContent.tsx.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customWrap"];

  toggleCustom(event) {
    const reason = event.params.reason;
    if (reason === "other") {
      this.customWrapTarget.classList.remove("hidden");
    } else {
      this.customWrapTarget.classList.add("hidden");
    }
  }
}
